// import React, { createContext, useState, useContext } from "react";

// const LoaderContext = createContext();

// export const LoaderProvider = ({ children }) => {
//   const [loading, setLoading] = useState(false);

//   const showLoader = () => setLoading(true);
//   const hideLoader = () => setLoading(false);

//   return (
//     <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
//       {/* Internal CSS for loader */}
//       <style>
//         {`
//           .loader-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background-color: rgba(255, 255, 255, 0.8);
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 2000;
//           }

//           .spinner {
//             width: 60px;
//             height: 60px;
//             border: 6px solid #e0e0e0;
//             border-top: 6px solid #007bff;
//             border-radius: 50%;
//             animation: spin 1s linear infinite;
//           }

//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>

//       {loading && (
//         <div className="loader-overlay">
//           <div className="spinner"></div>
//         </div>
//       )}
//       {children}
//     </LoaderContext.Provider>
//   );
// };

// export const useLoader = () => useContext(LoaderContext);





import React, { createContext, useState, useContext, useEffect } from "react";
 
const LoaderContext = createContext();
 
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
 
  const showLoader = () => {
    setLoading(true);
    setDataLoaded(false);
  };
 
  const hideLoader = () => {
    setDataLoaded(true);
  };
 
  // Data loaded होने के बाद थोड़ा delay के लिए
  useEffect(() => {
    if (dataLoaded) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 500); // Smooth transition के लिए थोड़ा delay
      return () => clearTimeout(timer);
    }
  }, [dataLoaded]);
 
  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {/* Internal CSS for loader */}
      <style>
        {`
          .loader-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.95);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 2000;
            font-family: 'Netflix Sans', 'Helvetica Neue', Arial, sans-serif;
            transition: opacity 0.3s ease;
          }
 
          .loader-overlay.fade-out {
            opacity: 0;
            pointer-events: none;
          }
 
          .netflix-loader {
            text-align: center;
          }
 
          .loading-text {
            font-size: 2rem;
            font-weight: 900;
            letter-spacing: 6px;
            margin-bottom: 30px;
            color: #fff;
          }
 
          .loading-letter {
            display: inline-block;
            opacity: 0;
            transform: translateY(30px);
            animation: netflixLetterAnimation 0.8s cubic-bezier(0.215, 0.610, 0.355, 1) forwards;
            text-shadow: 0 0 10px rgba(229, 9, 20, 0.5);
          }
 
          .loading-letter:nth-child(1) { animation-delay: 0.1s; color: #e50914; }
          .loading-letter:nth-child(2) { animation-delay: 0.2s; color: #e50914; }
          .loading-letter:nth-child(3) { animation-delay: 0.3s; color: #e50914; }
          .loading-letter:nth-child(4) { animation-delay: 0.4s; color: #e50914; }
          .loading-letter:nth-child(5) { animation-delay: 0.5s; color: #e50914; }
          .loading-letter:nth-child(6) { animation-delay: 0.6s; color: #e50914; }
          .loading-letter:nth-child(7) { animation-delay: 0.7s; color: #e50914; }
 
          @keyframes netflixLetterAnimation {
            0% {
              opacity: 0;
              transform: translateY(30px) scale(0.8);
            }
            50% {
              opacity: 1;
              transform: translateY(-8px) scale(1.1);
              text-shadow: 0 0 20px rgba(229, 9, 20, 0.8);
            }
            100% {
              opacity: 1;
              transform: translateY(0) scale(1);
              text-shadow: 0 0 10px rgba(229, 9, 20, 0.5);
            }
          }
 
          .netflix-bar {
            width: 300px;
            height: 4px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 2px;
            overflow: hidden;
            position: relative;
            margin: 0 auto;
          }
 
          .netflix-progress {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 0%;
            background: linear-gradient(90deg, #e50914, #ff6b6b);
            animation: netflixProgress 2s ease-in-out infinite;
            box-shadow: 0 0 10px rgba(229, 9, 20, 0.5);
          }
 
          @keyframes netflixProgress {
            0% {
              width: 0%;
              left: 0;
            }
            50% {
              width: 100%;
              left: 0;
            }
            100% {
              width: 0%;
              left: 100%;
            }
          }
 
          .loading-subtext {
            color: rgba(255, 255, 255, 0.7);
            margin-top: 25px;
            font-size: 1.1rem;
            letter-spacing: 1px;
            animation: subtlePulse 3s ease-in-out infinite;
          }
 
          @keyframes subtlePulse {
            0%, 100% { opacity: 0.6; }
            50% { opacity: 1; }
          }
 
          /* Netflix logo style dots */
          .netflix-dots {
            display: flex;
            justify-content: center;
            gap: 6px;
            margin-top: 25px;
          }
 
          .netflix-dot {
            width: 8px;
            height: 8px;
            background: #e50914;
            border-radius: 50%;
            animation: netflixDotPulse 1.5s ease-in-out infinite;
          }
 
          .netflix-dot:nth-child(1) { animation-delay: 0s; }
          .netflix-dot:nth-child(2) { animation-delay: 0.2s; }
          .netflix-dot:nth-child(3) { animation-delay: 0.4s; }
 
          @keyframes netflixDotPulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.5;
            }
            50% {
              transform: scale(1.3);
              opacity: 1;
              box-shadow: 0 0 8px rgba(229, 9, 20, 0.8);
            }
          }
        `}
      </style>
 
      {loading && (
        <div className={`loader-overlay ${dataLoaded ? 'fade-out' : ''}`}>
          <div className="netflix-loader">
            <div className="loading-text">
              {"MAAMAAS".split("").map((letter, index) => (
                <span key={index} className="loading-letter">
                  {letter}
                </span>
              ))}
            </div>
           
            <div className="netflix-bar">
              <div className="netflix-progress"></div>
            </div>
           
            <div className="netflix-dots">
              <div className="netflix-dot"></div>
              <div className="netflix-dot"></div>
              <div className="netflix-dot"></div>
            </div>
           
            <div className="loading-subtext">
              {dataLoaded ? "Ready!" : "Getting things ready for you..."}
            </div>
          </div>
        </div>
      )}
      {children}
    </LoaderContext.Provider>
  );
};
 
export const useLoader = () => useContext(LoaderContext);